export const initFloorLayout = ( slider ) => {
	const ID_REGEX = /APT-(?<id>P?[\d|-]+)_?/u;
	const floorLayout = slider.querySelector( 'li.floor-layout' );

	if ( !floorLayout )
	{
		return;
	}

	const floorData = JSON.parse( floorLayout.querySelector( 'div.data' ).innerHTML );

	if ( !floorData )
	{
		return;
	}

	const apartmentID = `APT-${floorData[0]}`;

	for ( const it of Array.from( floorLayout.querySelectorAll( '[id*="APT-"]' ) ) )
	{
		const match = it.id.match( ID_REGEX );

		if ( match && match.groups && match.groups.id && `APT-${match.groups.id}` === apartmentID )
		{
			it.dataset.active = 'yes';

			break;
		}
	}

	const guidSection = floorLayout.dataset.guidSection;
	const building = floorLayout.querySelector( 'svg' );
	const section = building.querySelector( `#SEC-${guidSection}` );

	if ( section )
	{
		floorLayout.classList.add( 'section-layout' );
		
		const baseRect = building.viewBox.baseVal;

		building.insertAdjacentHTML( 'beforeend', `<rect id="view_box" width="${baseRect.width}" height="${baseRect.height}" />` );

		const buildingRect = building.querySelector( 'rect#view_box' ).getBoundingClientRect();
		const sectionRect = section.getBoundingClientRect();
		const viewBoxRatio = baseRect.width / buildingRect.width;
		const updatedViewBox = `${Math.round( ( sectionRect.x - buildingRect.x ) * viewBoxRatio )} ${Math.round( ( sectionRect.y - buildingRect.y ) * viewBoxRatio )} ${Math.round( sectionRect.width * viewBoxRatio )} ${Math.round( sectionRect.height * viewBoxRatio )}`;

		building.setAttribute( 'viewBox', updatedViewBox );
		building.classList.add( 'show-section' );
		section.classList.add( 'show' );
	}

	floorLayout.classList.add( 'loaded' );
};
